/**
 * Created by fkurzawa on 12.06.18.
 */
export { default } from "./Pagination";
export { default as Pagination } from "./Pagination";
